import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { useCrmHostUrlContext } from '../../../components/resource-redirect/crm-host-url-context';
import { joinURL } from '../../../utilities';
import { useFeatureToggles } from '../../../feature-toggles';
import { adminAreaPathName, companyTabLabel, companyTabPathName } from '../admin-area-pathnames';
import {
  accountSpecialCircumstancesTypePathName,
  accountInteractionPurposePathName,
  accountInteractionResultPathName,
  accountTagTypePathName,
  accountGroupPathName,
} from './company-pathnames';

export function CompanyMenu() {
  const { url } = useCrmHostUrlContext();
  const { isFeatureEnabled } = useFeatureToggles();

  function handleClick(entityName: string) {
    const link = `${url}/main.aspx?etn=${entityName}&pagetype=entitylist`;
    window.open(link);
  }
  return (
    <Restricted actions={[{ resourceType: ResourceTypes.BusinessConfiguration, resourceOperation: ResourceOperations.Read }]}>
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, companyTabPathName)}>{companyTabLabel}</AdminHeaderLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, companyTabPathName, accountSpecialCircumstancesTypePathName)}>Aftaletyper</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, companyTabPathName, accountInteractionPurposePathName)}>Formål med virksomhedskontakter</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, companyTabPathName, accountInteractionResultPathName)}>Resultat af virksomhedskontakter</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, companyTabPathName, accountTagTypePathName)}>Tagtyper</AdminRouterLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, companyTabPathName, accountGroupPathName)}>Virksomhedsgrupper</AdminRouterLink>
    </Restricted>
  );
}
